import { AnyAction } from "redux";
import * as actionTypes from "./actionTypes";

export const getFantasyTournaments = (): AnyAction => ({
  type: actionTypes.FANTASY_TOURNAMENTS_GET_TOURNAMENTS,
});

export const clearFantasyTournaments = (): AnyAction => ({
  type: actionTypes.FANTASY_TOURNAMENTS_GET_TOURNAMENTS_CLEAR,
});